export const TALENT_DEMO_JOB = {
    id: 999,
    title: "Sample Developer Position",
    company_name: "Tech Innovations Inc.",
    location_city: "San Francisco",
    location_country: "USA",
    description: "This is a sample job for the onboarding tour",
    created_at: new Date().toISOString(),
    expiry_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    type: "Full-time",
    level: "mid_level",
    language: "mid_level",
    status: "open",
    closed: 0,
    has_liked: false,
    has_bookmarked: false,
    recruiter_id: "abcd-1234-efgh-5678",
    sector_id: 1,
    employment_type: "Permanent",
    years_of_experience: "2",
    location_id: 1,
    skills: ["JavaScript", "React", "Node.js"],
    recruiter: {
        id: 0,
        first_name: "Jane",
        last_name: "Smith",
        middle_name: "",
    },
};

export interface InviteDate {
    id: number;
    date: string; // ISO date format
}

export interface JobListing {
    id?: number;
    title: string;
    recruiter_id: string;
    sector_id: number;
    company_name: string;
    corporate_id?: string;
    employment_type: string;
    type: string;
    level: string;
    expiry_date: string;
    years_of_experience: string;
    description: string;
    location_id: number;
    location_city: string;
    location_country: string;
    token?: string;
    has_liked?: boolean;
    has_bookmarked?: boolean;
    recruiter?: any;
    views_count?: number;
    likes_count?: number;
    skills: string[];
    userInfo?: any;
    status: string;
    closed?: any;
    closed_at?: any;
    closed_reason?: any;
}

export interface TalentInvite {
    id: number;
    token: string;
    note: string;
    status: number;
    listing_id: string;
    dates: {
        id: number;
        listing_invite_id: number;
        date: string;
    }[];
    listing: JobListing;
    sent_offer: number;
    accepted_offer: number;
}

export const generateDemoInvites = (): TalentInvite[] => {
    const jobListings: JobListing[] = [
        {
            id: 1,
            recruiter_id: "1",
            title: "Senior Frontend Developer",
            location_city: "San Francisco, CA",
            location_country: "USA",
            company_name: "Tech Innovations Inc.",
            sector_id: 1,
            employment_type: "Full-time",
            type: "Frontend Development",
            level: "Senior",
            expiry_date: "2024-08-30",
            years_of_experience: "5+",
            description: "We're looking for an experienced frontend developer to join our team working on cutting-edge web applications using React and TypeScript.",
            location_id: 101,
            skills: ["React", "TypeScript", "CSS", "HTML"],
            status: "Active"
        },
        {
            id: 2,
            recruiter_id: "1",
            title: "UX Designer",
            location_city: "Remote",
            location_country: "Remote",
            company_name: "Creative Solutions LLC",
            sector_id: 2,
            employment_type: "Contract",
            type: "UX Design",
            level: "Mid-level",
            expiry_date: "2024-07-25",
            years_of_experience: "3-5",
            description: "Join our design team to create beautiful user experiences for enterprise SaaS products. Must have portfolio showing complex workflows.",
            location_id: 102,
            skills: ["UX Design", "Wireframing", "Prototyping", "User Research"],
            status: "Active"
        },
        {
            id: 3,
            recruiter_id: "1",
            title: "DevOps Engineer",
            location_city: "New York, NY",
            location_country: "USA",
            company_name: "Cloud Systems Co.",
            sector_id: 3,
            employment_type: "Full-time",
            type: "DevOps",
            level: "Mid-level",
            expiry_date: "2024-07-30",
            years_of_experience: "3-5",
            description: "Help us build and maintain our CI/CD pipelines and cloud infrastructure. Kubernetes and Terraform experience required.",
            location_id: 103,
            skills: ["CI/CD", "Kubernetes", "Terraform", "AWS"],
            status: "Active"
        },
        {
            id: 4,
            recruiter_id: "1",
            title: "Product Manager",
            location_city: "Austin, TX",
            location_country: "USA",
            company_name: "LaunchPad Startups",
            sector_id: 4,
            employment_type: "Full-time",
            type: "Product Management",
            level: "Senior",
            expiry_date: "2024-08-15",
            years_of_experience: "5+",
            description: "Lead product development for our new SaaS platform. Ideal talent has 5+ years experience in B2B software.",
            location_id: 104,
            skills: ["Product Management", "Agile", "SaaS", "Leadership"],
            status: "Active"
        }
    ];

    const datesPool: InviteDate[] = [
        { id: 1, date: "2024-07-15T14:00:00Z" },
        { id: 2, date: "2024-07-16T10:30:00Z" },
        { id: 3, date: "2024-07-17T13:45:00Z" },
        { id: 4, date: "2024-07-18T11:15:00Z" }
    ];

    return [
        // Pending invites (status = 0)
        {
            id: 101,
            token: "token-101", // Add token
            note: "Looking forward to your response!", // Add note
            status: 0,
            sent_offer: 0,
            accepted_offer: 0, // Add accepted_offer
            dates: [
                { id: 1, listing_invite_id: 101, date: datesPool[0].date },
                { id: 2, listing_invite_id: 101, date: datesPool[1].date }
            ],
            listing_id: "1",
            listing: jobListings[0]
        },
        {
            id: 102,
            token: "token-102", // Add token
            note: "Excited to have you onboard!", // Add note
            status: 0,
            sent_offer: 0,
            accepted_offer: 0, // Add accepted_offer
            dates: [
                { id: 3, listing_invite_id: 102, date: datesPool[2].date }
            ],
            listing_id: "2",
            listing: jobListings[1]
        },

        // Accepted invites (status = 1)
        {
            id: 201,
            token: "token-201", // Add token
            note: "Glad to have you accept the invite!", // Add note
            status: 1,
            sent_offer: 0,
            accepted_offer: 1, // Add accepted_offer
            dates: [
                { id: 1, listing_invite_id: 201, date: datesPool[0].date }
            ],
            listing_id: "3",
            listing: jobListings[2]
        },
        {
            id: 202,
            token: "token-202", // Add token
            note: "Job offer has been sent!", // Add note
            status: 1,
            sent_offer: 1, // Job offer has been sent
            accepted_offer: 1, // Add accepted_offer
            dates: [
                { id: 4, listing_invite_id: 202, date: datesPool[3].date }
            ],
            listing_id: "1",
            listing: jobListings[0]
        },

        // Declined invites (status = 2)
        {
            id: 301,
            token: "token-301", // Add token
            note: "Unfortunately, we will not be proceeding with this opportunity.", // Add note
            status: 2,
            sent_offer: 0,
            accepted_offer: 0, // Add accepted_offer
            dates: [
                { id: 2, listing_invite_id: 301, date: datesPool[1].date }
            ],
            listing_id: "4",
            listing: jobListings[3]
        },
        {
            id: 302,
            token: "token-302", // Add token
            note: "Thanks for your time, but we're going in a different direction.", // Add note
            status: 2,
            sent_offer: 0,
            accepted_offer: 0, // Add accepted_offer
            dates: [
                { id: 3, listing_invite_id: 302, date: datesPool[2].date }
            ],
            listing_id: "2",
            listing: jobListings[1]
        },

        // Job offers (sent_offer = 1)
        {
            id: 401,
            token: "token-401", // Add token
            note: "Offer has been sent and we await your response.", // Add note
            status: 1,
            sent_offer: 1,
            accepted_offer: 0, // Add accepted_offer
            dates: [],
            listing_id: "4",
            listing: jobListings[3]
        },
        {
            id: 402,
            token: "token-402", // Add token
            note: "Offer sent. Looking forward to your response.", // Add note
            status: 1,
            sent_offer: 1,
            accepted_offer: 0, // Add accepted_offer
            dates: [
                { id: 4, listing_invite_id: 402, date: datesPool[3].date }
            ],
            listing_id: "3",
            listing: jobListings[2]
        }
    ];
};


// Demo data generator
